// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"steps-template_wrapper__1c7Xs","stepper":"steps-template_stepper__3fdn8"};